import { PREDEFINED_REPORTS } from '../../../pages/menuUsers/reports/ReportTypes';
import React from 'react';

export const ReportType = (props: {
    reportType: string;
    scope: boolean;
}) => {
    return (
        <div style={{
            borderRadius: '4px',
            border: '1px solid #e2e8f0',
            background: '#ffffff',
            color: '#1a202c',
            padding: '4px 12px',
            margin: 2,
            minWidth: 240,
            width: '100%',
            boxSizing: 'border-box',
            justifySelf: 'start',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            fontSize: '13px',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
            lineHeight: 1.15,
        }}>
            <span style={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                fontWeight: '500',
            }}>
                {React.createElement(PREDEFINED_REPORTS[props.reportType].icon)}
                {PREDEFINED_REPORTS[props.reportType].name}
            </span>

            {props.scope && (
                <span style={{
                    fontSize: '0.8em',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    color: '#718096',
                    background: '#edf2f7',
                    padding: '1px 5px',
                    borderRadius: '3px',
                    alignSelf: 'flex-start',
                    lineHeight: 1.2,
                }}>
                    {PREDEFINED_REPORTS[props.reportType].scopeName}
                </span>
            )}
        </div>
    );
};
